import Devise from "@kaspernj/api-maker/build/devise"
import {User} from "models"

Devise.addUserScope("user", {
  query: User.ransack().preload(["user_roles.role"])
})
